import { createAsyncAction } from 'src/redux/actions';
import { StatuspageIncident } from 'src/types/statuspage';

const prefixed = (action: string) => `global/${action}`;

export const LOAD_STATUSPAGE_INCIDENTS = createAsyncAction(
  prefixed('LOAD_STATUSPAGE_INCIDENTS')
);

export type LoadStatuspageIncidentsAction = {
  type: string;
  payload: object[];
};

export const LoadStatusPageIncidentsSuccess = (
  incidents: StatuspageIncident[]
) => ({
  type: LOAD_STATUSPAGE_INCIDENTS.SUCCESS,
  payload: incidents,
});

export const LoadStatusPageIncidentsError = (error: string) => ({
  type: LOAD_STATUSPAGE_INCIDENTS.ERROR,
  error,
});
